window.addEventListener('load', function () {
    if (document.querySelectorAll('.terms .toggle-more').length) {
        document.addEventListener('click', function (e) {
            if (e.target && e.target.classList.contains('toggle-more')) {
                var button = e.target;

                var parentEl = button.parentNode;

                parentEl.classList.toggle('show-less');

                [...button.parentNode.querySelectorAll('.more-item')].forEach(function (e) {
                    e.classList.toggle('hidden');
                });

                button.innerText = parentEl.classList.contains('show-less') ? button.dataset.textMore : button.dataset.textLess;
            }
        });
    }
});
